import React from 'react';
import styled from "styled-components";
import { ReactComponent as MapPin } from '../../resources/images/mappin.svg';
import { ReactComponent as Calendar } from '../../resources/images/daily_calendar.svg';
import {Tag} from "../../resources/styles";

const MapPinIcon = styled(MapPin)`
    fill: ${props => props.theme.buttonBackground || '#6B207D'};
    stroke: ${props => props.theme.buttonBackground || '#6B207D'};
`;

const CalendarIcon = styled(Calendar)`
    fill: ${props => props.theme.buttonBackground || '#6B207D'};
    stroke: ${props => props.theme.buttonBackground || '#6B207D'};
`;


const ExcursionFacts = ({date, itineraryInfo}) => {
    return (
        <div>
            { date &&
                <div className="flex items-center mb-2">
                    <Tag>
                        <CalendarIcon/>
                    </Tag>
                    <span>{date}</span>
                </div>
            }
            { itineraryInfo &&
                <div className="flex items-center">
                    <Tag>
                        <MapPinIcon/>
                    </Tag>
                    <span>{itineraryInfo}</span>
                </div>
            }
        </div>
    )
}

export default ExcursionFacts;